{
    "contextmenu": {
        "global": {
            "cut": "Cut",
            "copy": "Copy",
            "paste": "Paste",
            "selectAll": "Select all",
            "print": "Print"
        },
        "control": {
            "delete": "Delete control"
        },
        "hyperlink": {
            "delete": "Delete hyperlink",
            "cancel": "Cancel hyperlink",
            "edit": "Edit hyperlink"
        },
        "image": {
            "change": "Change image",
            "saveAs": "Save as image",
            "textWrap": "Text wrap",
            "textWrapType": {
                "embed": "Embed",
                "upDown": "Up down",
                "surround": "Surround",
                "floatTop": "Float above text",
                "floatBottom": "Float below text"
            }
        },
        "table": {
            "insertRowCol": "Insert row col",
            "insertTopRow": "Insert top 1 row",
            "insertBottomRow": "Insert bottom 1 row",
            "insertLeftCol": "Insert left 1 col",
            "insertRightCol": "Insert right 1 col",
            "deleteRowCol": "Delete row col",
            "deleteRow": "Delete 1 row",
            "deleteCol": "Delete 1 col",
            "deleteTable": "Delete table",
            "mergeCell": "Merge cell",
            "mergeCancelCell": "Cancel merge cell",
            "verticalAlign": "Vertical align",
            "verticalAlignTop": "Top",
            "verticalAlignMiddle": "Middle",
            "verticalAlignBottom": "Bottom",
            "border": "Table border",
            "borderAll": "All",
            "borderEmpty": "Empty",
            "borderDash": "Dash",
            "borderExternal": "External",
            "borderInternal": "Internal",
            "borderTd": "Table cell border",
            "borderTdTop": "Top",
            "borderTdRight": "Right",
            "borderTdBottom": "Bottom",
            "borderTdLeft": "Left",
            "borderTdForward": "Forward",
            "borderTdBack": "Back"
        }
    },
    "datePicker": {
        "now": "Now",
        "confirm": "Confirm",
        "return": "Return",
        "timeSelect": "Time select",
        "weeks": {
            "sun": "Sun",
            "mon": "Mon",
            "tue": "Tue",
            "wed": "Wed",
            "thu": "Thu",
            "fri": "Fri",
            "sat": "Sat"
        },
        "year": " ",
        "month": " ",
        "months": {
            "jan": "Jan",
            "feb": "Feb",
            "mar": "Mar",
            "apr": "Apr",
            "may": "May",
            "jun": "Jun",
            "jul": "Jul",
            "aug": "Aug",
            "sep": "Sep",
            "oct": "Oct",
            "nov": "Nov",
            "dec": "Dec"
        },
        "hour": "Hour",
        "minute": "Minute",
        "second": "Second"
    },
    "frame": {
        "header": "Header",
        "footer": "Footer"
    },
    "pageBreak": {
        "displayName": "Page Break"
    },
    "zone": {
        "headerTip": "Double click to edit header",
        "footerTip": "Double click to edit footer"
    },
    "accessibility": {
        "selected": "Selected: ",
        "input": "Input: "
    }
}
